import {
  API_STATUS_MASTER,
  CLEAR_API_STATUS,
  SET_ADMIN_APPROVAL_CONFIG,
  SET_DRUG_TYPES,
} from "./types";

import { initialState } from "./initialState";

const applicationConfigsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case API_STATUS_MASTER:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case CLEAR_API_STATUS:
      return {
        ...state,
        apiStatus: initialState.apiStatus,
      };

    case SET_ADMIN_APPROVAL_CONFIG:
      return {
        ...state,
        approvalConfigs: action.payload,
      };

    case SET_DRUG_TYPES:
      return {
        ...state,
        drugTypes: action.payload,
      };

    default:
      return state;
  }
};

export default applicationConfigsReducer;